import React, { Component } from 'react';
import { Route } from 'react-router-dom'

import Sidebar from '../components/Sidebar';
import Dashboard from './Dashboard';
import ListEtablissements from './ListEtablissements';
import MetricsEtablissement from './MetricsEtablissement';
import BillsList from './BillsList';
import Profile from './Profile';
import Logout from './Logout';
import MobileHeader from '../components/MobileHeader';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'nvd3/build/nv.d3.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '../assets/pe7-icons/css/helper.css';
import '../assets/pe7-icons/css/pe-icon-7-stroke.css';
import '../style/App.css';

class App extends Component {

  render() {
    return (
      <div className="app-container">
        <div className="app-main">
          <Sidebar />
          <div className="app-main-outer">
            <div className="app-main-inner">
              <MobileHeader />
              <Route path="/app" component={Dashboard} exact/>
              <Route path="/app/etablissements" component={ListEtablissements} exact/>
              <Route path="/app/etablissements/:hash" component={MetricsEtablissement} exact/>
              <Route path="/app/bills" component={BillsList} exact/>
              <Route path="/app/profile" component={Profile} exact/>
              <Route path="/app/logout" component={Logout} exact/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js